export default "__VITE_ASSET__0bb4e188__"